<template>
  <div class="w-100 pt-livetv">
    <div class="container-fluid overflow-hidden">
      <div class="row mt-2">
        <div class="col-12">
          <CategoryPodcast :obj="categories" :cat_id="categories_id" />
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-12">
          <LatestPodcast />
        </div>
      </div>

      <!-- ads top -->
      <billboardBannerTop v-if="desktop"></billboardBannerTop>
      <mrecBannerTop v-if="mobile"></mrecBannerTop>

      <!-- covid19 podcast -->
      <!-- <div class="w-100 my-2">
        <RailLandscape
          :program_id="4858"
          :datasource="'podcast'"
          :cat="'covid-19-health-protocol'"
          :title="'COVID-19 Health Protocol'"
        />
      </div> -->

      <div
        class="w-100 mb-5"
        v-for="(items, index) in categories_id"
        :key="'cat_id' + items"
      >
        <RailLandscape
          :cat_id="items"
          :datasource="'podcast'"
          :cat="convertStringToLower(categories[index].replace(/\s/g, ''))"
          :title="categories[index]"
        />
        <div class="w-100" v-if="index == 2">
          <billboardBannerMiddle v-if="desktop"></billboardBannerMiddle>
          <mrecBannerMiddle v-if="mobile"></mrecBannerMiddle>
        </div>
      </div>

      <!-- ads bottom -->
      <billboardbannerbottom v-if="desktop"></billboardbannerbottom>
      <mrecbannerbottom v-if="mobile"></mrecbannerbottom>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import noimage from "../assets/podcast-no-image.png";
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
// ads
import billboardBannerTop from "../components/ads/v2/podcast/billboardBannerTop.vue";
import mrecBannerTop from "../components/ads/v2/podcast/mrecBannerTop.vue";
import billboardBannerMiddle from "../components/ads/v2/podcast/billboardBannerMiddle.vue";
import mrecBannerMiddle from "../components/ads/v2/podcast/mrecBannerMiddle.vue";
import BillboardBannerBottom from "../components/ads/v2/podcast/billboardBannerBottom.vue";
import MrecBannerBottom from "../components/ads/v2/podcast/mrecBannerBottom.vue";
import LatestPodcast from "../components/carousel/podcast/podcastLatestPodcast.vue";
import PodcastMasthead from "../components/carousel/podcastMasthead.vue";
import CategoryPodcast from "../components/categoryPodcast.vue";

export default {
  data: function() {
    return {
      podcast: [],
      podcast_each: [],
      noimage: noimage,
      mnnlink: "/play?scheme=205&p_type=true&id=1387&eps_id=",
      categories: [
        "Exclusives",
        "Culture",
        "Drama",
        "Entertainment",
        "Infotainment",
        "Religious",
        "Mandarin",
      ],
      categories_id: ["861", "720", "722", "723", "189", "721", "939"],
      tablet: false,
      mobile: false,
      desktop: false,
    };
  },
  components: {
    billboardBannerTop: billboardBannerTop,
    mrecBannerTop: mrecBannerTop,
    billboardBannerMiddle: billboardBannerMiddle,
    mrecBannerMiddle: mrecBannerMiddle,
    billboardbannerbottom: BillboardBannerBottom,
    mrecbannerbottom: MrecBannerBottom,
    BreadCrumbsHeader,
    PodcastMasthead,
    CategoryPodcast,
    LatestPodcast,
  },
  methods: {
    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
    imageLoadError(event) {
      event.target.src = noimage;
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        margin: 10,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            nav: true,
            stagePadding: 0,
          },
          600: {
            items: 3,
            nav: true,
            stagePadding: 50,
          },
          768: {
            items: 5,
            stagePadding: 50,
            loop: false,
          },
        },
      });
    },
    checkLink(item) {
      var idSchema, check;
      var id = item.id;
      var title = item.data.title;

      var link;

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      } else if (item.idSchema == "203") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/podcastplayer?id=" + item.id;
      } else if (idSchema == "204") {
        //pod episode
        link = "/podcastplayer?id=" + item.id;
      }

      return link;
    },
    imgFiltering(item) {
      var imgurl;
      //check if
      var checkThumbnail =
        item.data && item.data.images && item.data.images.thumbnail;
      var checkTitle = item.data && item.data.images && item.data.images.title;
      var checkImgFeature =
        item.data && item.data.images && item.data.images.feature;

      if (checkThumbnail) {
        imgurl =
          "https://rtb-images.glueapi.io/500x0/" +
          item.data.images.thumbnail.path;
      } else {
        if (checkTitle) {
          imgurl =
            "https://rtb-images.glueapi.io/500x0/" +
            item.data.images.title.path;
        } else {
          if (checkImgFeature) {
            imgurl =
              "https://rtb-images.glueapi.io/500x0/" +
              item.data.images.feature.path;
          } else {
            imgurl =
              "https://cdn-rtb.glueapi.io/v1/content/" +
              item.id +
              "/image/300x0/images.title";
          }
        }
      }
      return imgurl;
    },
    filterPodFolder() {
      var vm = this;
      vm.podcast = this.$store.state.podcast.data;

      var store = [];
      var imgurl;
      vm.podcast.forEach((item) => {
        item["img_link"] = this.imgFiltering(item);
        store.push(item);
      });
      vm.podcast = store;
      if (vm.podcast) {
        this.filterBasedOnCategory();
      }
    },
    goTo(link) {
      this.$router.push(link);
    },
    goToBanner(link) {
      this.$router.push(link);
    },
    imageLoadError(event) {
      event.target.src = noimage;
    },
    filterBasedOnCategory() {
      var obj = this.podcast;
      var categories = this.categories;
      var each = {};
      // this.podcast_each;
      obj.forEach((items) => {
        var content_type = items.data.category;

        if (content_type.length != 0) {
          content_type.forEach((items_cat) => {
            for (var i = 0; i < categories.length; i++) {
              if (
                items_cat.title.en_US === categories[i] ||
                items_cat.title.en_US ===
                  this.convertStringToLower(categories[i]) ||
                items_cat.title.en_US ===
                  this.convertStringToLower(categories[i].replace(/\s/g, ""))
              ) {
                if (
                  each[
                    this.convertStringToLower(categories[i].replace(/\s/g, ""))
                  ]
                ) {
                  each[
                    this.convertStringToLower(categories[i].replace(/\s/g, ""))
                  ].push(items);
                } else {
                  each[
                    this.convertStringToLower(categories[i].replace(/\s/g, ""))
                  ] = [items];
                }
              }
            }
          });
        }
      });
      this.podcast_each.push(each);
    },
    convertStringToLower(items) {
      var strings;
      strings = items.toLowerCase();
      return strings;
    },
    initializepageview() {
      var self = this;
      // console.log(this.$route.path);
      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: this.$route.path,
          title: "vod",
          site: "RTBGo",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
  },
  created: function() {
    this.$store.dispatch("fetchPodFolder", { self: this });
  },
  mounted() {
    this.deviceCheck();
    if (!this.$route.params.id) {
      setTimeout(
        function() {
          this.initializepageview();
        }.bind(this),
        700
      );
    }
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 20px 0 0;
}
.breadCrumbsWrapper {
  padding: 30px;
}

@media only screen and (max-width: 768px) {
  .pt-livetv {
    padding: 8px 0 0;
  }
  .breadCrumbsWrapper {
    padding: 16px;
  }
}
</style>
